import { useState } from 'react';
import PropTypes from 'prop-types';
import BoatProForm from './BoatProForm';
import ClubForm from './ClubForm';
import {
  PRODUCT_BOAT_PRO,
  PRODUCT_BUILDER_ARTICLE,
  PRODUCT_CAPTAINS_CLUB,
  PRODUCT_OWNERS_CLUB
} from './constants';

const SalesforceLead = ({ leadSource, buttonCaption, embed, successMessage, modalTitle }) => {
  const [modalOpen, setModalOpen] = useState(false);

  if (embed !== 'false') {
    return (
      <>
        {[PRODUCT_BOAT_PRO, PRODUCT_BUILDER_ARTICLE].includes(leadSource) && (
          <BoatProForm embed leadSource={leadSource} successMessage={successMessage} />
        )}

        {[PRODUCT_CAPTAINS_CLUB, PRODUCT_OWNERS_CLUB].includes(leadSource) && (
          <ClubForm product={leadSource} embed successMessage={successMessage} />
        )}
      </>
    );
  }

  return (
    <>
      <a className="button button--center" onClick={() => setModalOpen(true)}>
        {buttonCaption}
      </a>

      {modalOpen && (
        <div className="overlay">
          <div className="boat-pro-form modal modal--contact modal--show">
            <header className="modal__header modal__header--contact">
              <div className="modal__title">{modalTitle}</div>

              <div
                role="button"
                className="boat-pro-form__close-bar-wrapper"
                onClick={() => setModalOpen(false)}
                data-testid="close-button">
                <div className="boat-pro-form__close-bar boat-pro-form__close-bar--left" />

                <div className="boat-pro-form__close-bar boat-pro-form__close-bar--right" />
              </div>
            </header>

            {(leadSource === PRODUCT_BOAT_PRO || leadSource === PRODUCT_BUILDER_ARTICLE) && (
              <BoatProForm embed={false} leadSource={leadSource} successMessage={successMessage} />
            )}

            {[PRODUCT_CAPTAINS_CLUB, PRODUCT_OWNERS_CLUB].includes(leadSource) && (
              <ClubForm product={leadSource} embed={false} />
            )}

            {leadSource === PRODUCT_BOAT_PRO && (
              <div className="boat-pro-form__bottom-logo">BOAT</div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

SalesforceLead.propTypes = {
  leadSource: PropTypes.string.isRequired,
  buttonCaption: PropTypes.string.isRequired,
  embed: PropTypes.string,
  successMessage: PropTypes.string,
  modalTitle: PropTypes.string.isRequired
};

SalesforceLead.defaultProps = {
  embed: '',
  successMessage: ''
};

export default SalesforceLead;
